import React, { useState, useMemo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Rate, Row, Col, Typography, Skeleton, Drawer } from "antd";
import moment from "moment";
import { RestaurantRate } from "./Rate";
import { slimImage } from "@/service/utils";
import { RightOutlined } from "@ant-design/icons";
import { Icon, Header, Button } from "@/components";
import { useStores } from "@/store";
import { getQuery } from "@/service/http";
function padRight(str) {
  return Number(str).toFixed(1);
}
/**评分&评论 */
export const Reviews = ({ restaurant }) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [list, setList] = useState([]);
  const [currentReview, setCurrentReview] = useState({});
  const [page, setPage] = useState(1);
  const [showMore, setShowMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const { restaurantStore } = useStores();

  useEffect(() => {
    setPage(1);
    onLoadMore(1);
  }, [restaurant]);

  useEffect(() => {
    if (page > 1) {
      onLoadMore(20);
    }
  }, [page]);

  const count = useMemo(() => {
    return restaurant.reviews_count;
  }, [restaurant]);

  const first = useMemo(() => {
    return list[0] || null;
  }, [list]);

  /**加载更多 */
  async function onLoadMore(per_page) {
    setLoading(true);
    let data = await restaurantStore.getReviews(page,null,per_page);
    let newList = [];
    if (page > 1) {
      newList = list.concat(data);
    } else {
      newList = data;
    }

    setShowMore(newList.length < count);
    setLoading(false);
    setList(newList);
  }

  /**查看详情 */
  function onShow(item) {
    setCurrentReview(item);
    setVisible2(true);
  }

  /**查看大图 */
  function onPreview() {}

  async function  viewAll() {
    onLoadMore(20);
    setVisible(true);
  }
  async function  showMoreReviews() {
    setPage(page + 1)
    onLoadMore(20);
    setVisible(true);
  }
  return (
    <section className="page-restaurant--reviews" hidden={count == 0}>
      <h3>{t("WEB.Reviews", { count: count })}</h3>
      <RestaurantRate restaurant={restaurant} />
      {first ? (
        <ReviewItem
          review={first}
          onPreview={onPreview}
          onClick={() => viewAll()}
        />
      ) : null}
      <div
        className="hairline-bottom"
        style={{ height: 10, marginBottom: 10, marginTop: -10 }}
      ></div>
      <footer className="view-all flex" onClick={() => viewAll()}>
        <span>{t("WEB.View all")}</span>
        <RightOutlined />
      </footer>

      {/* 详情 */}
      <ReviewDetail
        review={currentReview}
        onPreview={onPreview}
        visible={visible2}
        setVisible={setVisible2}
      />

      {/* 列表 */}
      <Drawer
        className="restaurant-drawer reviews-drawer"
        data-left={visible2}
        placement="right"
        closable={false}
        destroyOnClose
        onClose={() => setVisible(false)}
        visible={visible}
      >
        <Header
          title={t("WEB.ReviewsTitle")}
          onClick={() => setVisible(false)}
        />
        <h3>{t("WEB.Reviews", { count: restaurant.reviews_count })}</h3>
        <div style={{ marginBottom: 10 }}>
          <RestaurantRate restaurant={restaurant} />
        </div>
        {list.map((item) => {
          return (
            <ReviewItem
              key={item.id}
              review={item}
              mobile={true}
              onPreview={onPreview}
              onClick={() => onShow(item)}
            />
          );
        })}
        <div className="show-load">
          {showMore && (
            <Button
              type="primary"
              block
              onClick={() => showMoreReviews()}
              loading={loading}
            >
              {t("WEB.Show more reviews")}
            </Button>
          )}
        </div>
      </Drawer>
    </section>
  );
};

/**评论详情 */
export const ReviewDetail = ({ review, onPreview, visible, setVisible }) => {
  const { t } = useTranslation();
  const { restaurantStore } = useStores();
  const [replies, setReplies] = useState([]);
  const comment = { ...review };
  comment.photos = [];
  useEffect(() => {
    if (!review.id) return;
    restaurantStore.getReplies(review.id).then(setReplies);
  }, [review.id]);

  return (
    <Drawer
      className="restaurant-drawer reviews-drawer"
      placement="right"
      closable={false}
      destroyOnClose
      onClose={() => setVisible(false)}
      visible={visible}
    >
      <Header title={t("Details")} onClick={() => setVisible(false)} />
      <ReviewItem
        review={review}
        onPreview={onPreview}
        showRateDetail={true}
        mobile={true}
        showAll={true}
      />
      <div hidden={!replies.length}>
        <h3>{t("WEB.comments", { count: replies.length })}</h3>
        <div className="review-comments">
          {replies.map((item) => {
            return <ReviewItem mobile={true} showAll={true} key={item.id} review={item} />;
          })}
        </div>
      </div>
    </Drawer>
  );
};

export const ReviewItem = ({
  review,
  onPreview,
  onClick,
  showRateDetail,
  showAll,
  mobile,
}) => {
  const { t } = useTranslation();
  const format = getQuery().lang == "en" ? "MMMMDD, YYYY" : "LL";
  const date = moment(review.created_at).format(format);
  const { avatar_url, level } = review.member || review.owner || {};
  const {
    photos = [],
    rating_atmosphere,
    rating_cuisine,
    rating_service,
  } = review;
  const span = mobile ? { span: 8 } : { span: 8, md: 4, sm: 8 };
  const avg = useMemo(() => {
    return (rating_atmosphere + rating_cuisine + rating_service) / 3 / 2;
  }, [review]);
  const name = useMemo(() => {
    return review.name_reviewer || review.name;
  }, [review]);
  const content = useMemo(() => {
    return review.review_text || review.content;
  }, [review]);
  const photoList = useMemo(() => {
    return showAll ? photos : photos.slice(0, 6);
  }, [review]);
  return (
    <div className="review-item" onClick={onClick}>
      <div className="review-avatar">
        <div className="review-avatar-pic">
          <img src={avatar_url} alt="" />
        </div>
        <div className="review-level">
          <i className={"icon icon-" + level}></i>
        </div>
        <div className="review-levelname small">{t(`LEVELS.${level}`)}</div>
      </div>
      <div className="review-info">
        <div className="review-author">{name}</div>
        <time className="review-date">
          <span className="small">{date}</span>
        </time>
        <div className="review-tag" hidden={!review.verified}>
          <i className="icon icon-verified"></i>
          <span className="small">{t("WEB.Verified")}</span>
        </div>
        {/* 评分 */}
        <div className="review-rate" data-detail={showRateDetail}>
          <Rate count={5} value={avg} disabled style={{ fontSize: 12 }} />
          <div className="review-rate-detail" hidden={!showRateDetail}>
            <div className="rate-item">
              <div className="rate-item-label">{t("WEB.Food")}</div>
              <div className="rate-item-value">{padRight(rating_cuisine)}</div>
            </div>
            <div className="rate-item">
              <div className="rate-item-label">{t("WEB.Service")}</div>
              <div className="rate-item-value">{padRight(rating_service)}</div>
            </div>
            <div className="rate-item">
              <div className="rate-item-label">{t("WEB.Decor")}</div>
              <div className="rate-item-value">
                {padRight(rating_atmosphere)}
              </div>
            </div>
          </div>
        </div>

        {/* 评论 */}
        {showAll ? (
          <div className="review-desc">
            <div>{content}</div>
          </div>
        ) : (
          <div className="review-desc">
            <Typography.Paragraph ellipsis={{ rows: 2 }}>
              {content}
            </Typography.Paragraph>
            <div className="pc-text">{content}</div>
          </div>
        )}

        {/* 配图 */}
        <div className="review-pics">
          <Row gutter={6} justify="start">
            {photoList.map((item, index) => {
              return (
                <Col key={index} {...span}>
                  <div className="review-pic">
                    <img
                      src={slimImage(item.image_url, "/w/180/h/124")}
                      onClick={() => onPreview(index, photos)}
                    />
                  </div>
                </Col>
              );
            })}
          </Row>
        </div>
        {/* 操作 */}
        <div className="review-actions">
          <Icon icon="icon icon-review-grey" text={review.replies_count} />
          <Icon icon="icon icon-heart" text={review.upvotes} />
        </div>
      </div>
    </div>
  );
};
